import React, { useState, useCallback, Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import SponsorshipEmailPopup from '../../../src/components/popup/SponsorshipEmailPopup';
import i18n from '../../i18n';
import Analytics from '../../utils/analytics';
import useGTM from '../analytics/useGTM';
import { Icon } from '@homeexchange/design';

const SponsorshipPopup = (props) => {
    const [copied, setCopied] = useState(false);
    const [pageEmail, setPageEmail] = useState(false);
    const [readyGapi, setReadyGapi] = useState(false);
    const [whichOne, setWhichOne] = useState('');
    const href = `${window.location.origin}/?sponsorkey=${props.sponsorhipKey}`;
    const action = [
        {
            icon: 'Envelope',
            text: i18n.t('sponsorship:invite_email'),
            type: 'email'
        },
        {
            icon: 'Copy',
            text: i18n.t('sponsorship:copy_link'),
            link: href,
            type: 'copy_link'
        },
        {
            icon: 'Facebook',
            text: i18n.t('sponsorship:share_facebook'),
            link: href,
            path: true,
            type: 'facebook'
        },
        {
            icon: 'Messenger',
            text: i18n.t('sponsorship:share_messenger'),
            link: href,
            type: 'messenger'
        },
        {
            icon: 'X',
            text: i18n.t('sponsorship:share_twitter'),
            link: `https://twitter.com/intent/tweet?text=${i18n.t(
                'sponsorship:sending_referral_link'
            )}&url=${href}`,
            type: 'twitter'
        }
    ];

    const onCopy = (whichone) => {
        setWhichOne(whichone);
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 1000);
    };

    const handleCopyToClipboard = (text, children, whichone) => {
        const copyToClipboard = (
            <CopyToClipboard
                text={text}
                // eslint-disable-next-line react/jsx-no-bind
                onCopy={() => onCopy(whichone)}
            >
                {children}
            </CopyToClipboard>
        );
        return copyToClipboard;
    };

    const onTrack = (type) => {
        const { fetchAccount } = useGTM(props.user);
        Analytics.trackGTM('SponsorshipCodeSend', fetchAccount(null, type));
    };

    const handleClick = (item) => {
        onTrack(item.type);

        switch (item.type) {
            case 'email':
                setPageEmail(true);
                break;
            case 'twitter':
                window.open(item.link, '_blank', 'noopener');
                break;
            case 'facebook':
            case 'messenger':
                window.FB.ui({
                    method: item.icon === 'Facebook' ? 'share' : 'send',
                    app_id: process.env.FACEBOOK_APP_ID,
                    ...(item.icon === 'Facebook'
                        ? {
                              href,
                              quote: `${i18n.t('sponsorship:sending_referral_link')} ${href}`
                          }
                        : { link: href })
                });
                break;
            default:
        }
    };

    const listReferral = () => {
        const arrayAction = [];
        action.forEach((item) => {
            if (item.type === 'copy_link') {
                const modalLink = (
                    <div className="modal-link" onClick={() => onTrack(item.type)}>
                        <div className="modal-link-icon">
                            <Icon name={item.icon} />
                        </div>
                        <div>{copied && whichOne === 'modalLink' ? i18n.t('common:copied') : item.text}</div>
                    </div>
                );
                arrayAction.push(
                    <Fragment key={item.icon}>
                        {handleCopyToClipboard(item.link, modalLink, 'modalLink')}
                    </Fragment>
                );
            } else {
                arrayAction.push(
                    <div
                        key={item.icon}
                        // eslint-disable-next-line react/jsx-no-bind
                        onClick={() => handleClick(item)}
                        className="modal-link"
                    >
                        <div className="modal-link-icon">
                            <Icon name={item.icon} />
                        </div>
                        <div>{item.text}</div>
                    </div>
                );
            }
        });
        return arrayAction.map((item) => item);
    };

    const closeModal = useCallback(() => {
        props.setOpenPopup(false);
        setPageEmail(false);
    }, []);

    const close = (onHide) => {
        if (onHide) {
            setReadyGapi(false);
            setPageEmail(false);
            props.setOpenPopup(false);
        }
        if (pageEmail && readyGapi) {
            setReadyGapi(false);
        } else if (pageEmail) {
            setPageEmail(false);
        } else {
            props.setOpenPopup(false);
        }
    };

    const modalSponsorshipKey = (
        <div className="sponsorship-key-container">
            <div
                className={`sponsorship-key ${copied && whichOne === 'modalSponsorshipKey' ? 'copied' : ''}`}
            >
                {copied && whichOne === 'modalSponsorshipKey' ? i18n.t('common:copied') : props.sponsorhipKey}
            </div>
        </div>
    );

    return (
        <Modal
            show={props.openPopup}
            /* eslint-disable react/jsx-no-bind */
            onHide={() => close(true)}
            className="modal-sponsorship"
        >
            <Modal.Header>
                <div className="modal-header-close">
                    <Icon name="Cross" onClick={() => close(false)} />
                </div>
            </Modal.Header>
            {!pageEmail ? (
                <Modal.Body>
                    <h4>{i18n.t('sponsorship:invite-friends')}</h4>
                    <p>{i18n.t('sponsorship:share-code')}</p>
                    {handleCopyToClipboard(props.sponsorhipKey, modalSponsorshipKey, 'modalSponsorshipKey')}
                    <p
                        className="modal-encourage"
                        dangerouslySetInnerHTML={{
                            __html: i18n.t('sponsorship:encourage_them')
                        }}
                    />
                    <div className="modal-link-container">{listReferral()}</div>
                </Modal.Body>
            ) : (
                <SponsorshipEmailPopup
                    closeModal={closeModal}
                    readyGapi={readyGapi}
                    setReadyGapi={setReadyGapi}
                    user={props.user}
                />
            )}
        </Modal>
    );
};

SponsorshipPopup.propTypes = {
    sponsorhipKey: PropTypes.string,
    openPopup: PropTypes.bool,
    setOpenPopup: PropTypes.func,
    user: PropTypes.object
};

export default SponsorshipPopup;
